import { mergeDeep } from "@perxis-auto/shared/lib/lib/merge/deepMerge";
import { COLLECTION_IDS } from "../../../config/collections.js";
import "../../../config/env.js";
import "../../../config/events.js";
import { mergeConstructor } from "../../../lib/constructor/mergeConstructor.js";
import "../../../lib/store/createAppApi.js";
import "../../../lib/store/createAppAsyncThunk.js";
import "../../../lib/store/createAppSelector.js";
import { createAppSlice } from "../../../lib/store/createAppSlice.js";
import "react";
import "redux";
import "../../../lib/store/hooks/useAppDispatch.js";
import "../../../lib/store/hooks/useAppSelector.js";
import "../../../lib/store/hooks/useAppStore.js";
import { CurrencyEnum, LanguageEnum } from "../../../types/internationalization.js";
import { LocationMarkerEnum } from "../../../types/location.js";
import { MapProviderEnum } from "../../../types/maps.js";
import { NavigationRouterTypeEnum } from "../../../types/router.js";
import { name } from "../config/name.js";
const initialState = {
  element: "",
  apiRoot: "",
  apiKey: "",
  spaceId: "",
  envId: "",
  navigation: {
    type: NavigationRouterTypeEnum.Hash
  },
  language: LanguageEnum.Ru,
  currency: CurrencyEnum.RUB,
  locationMarker: LocationMarkerEnum.City,
  models: {
    useAggregatePrice: false,
    useGroupingByBrand: false
  },
  media: {
    apiRoot: "",
    templates: {
      original: {
        path: "originals/{id}/original?width={width}&height={height}&fmt={format}&fit=cover"
      },
      resize: {
        path: "originals/{id}/original?width={width}&height={height}&fmt={format}&fit=force"
      },
      crop: {
        path: "originals/{id}/original?width={width}&height={height}&fmt={format}&fit=bounds&crop={width},{height}"
      }
    }
  },
  maps: {
    key: "",
    provider: MapProviderEnum.Yandex
  },
  sort: {
    enable: true,
    initialValues: ["price"],
    items: [
      {
        key: "price",
        label: "widgets.vehiclesCatalogHeader.sort.price",
        icon: "sort-up"
      },
      {
        key: "-price",
        label: "widgets.vehiclesCatalogHeader.sort.price",
        icon: "sort-down"
      }
    ]
  },
  filters: {
    initialValues: {},
    immutableValues: {}
  },
  booking: {
    enable: false,
    apiRoot: "",
    collectionId: COLLECTION_IDS.vehiclesBooking
  }
};
const slice = createAppSlice({
  name,
  initialState,
  reducers: {
    reset: () => initialState,
    set: (state, action) => action.payload,
    update: (state, action) => {
      return mergeDeep(state, action.payload);
    },
    mergeLayout: (state, action) => {
      var _a, _b, _c;
      const mergedLayout = {};
      for (const page of Object.keys(state.layout || {})) {
        mergedLayout[page] = mergeConstructor(
          ((_a = state.layout) == null ? void 0 : _a[page]) ?? ((_b = initialState.layout) == null ? void 0 : _b[page]),
          (_c = action.payload) == null ? void 0 : _c[page]
        );
      }
      state.layout = mergedLayout;
    }
  }
});
const { reducer, actions, reducerPath } = slice;
export {
  actions,
  initialState,
  reducer,
  reducerPath,
  slice
};
